<template>
  <el-table-column label="Actions" width="80" header-align="center">
    <template #default="scope">
      <div class="text-center">
        <el-dropdown trigger="click">
          <el-button type="primary" size="small" plain> ... </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="handleArchive(scope.row)"
                >Archive Reviewer</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </template>
  </el-table-column>
</template>

<script setup>
import { useReviewers, useTable } from "@/stores";

const tableStore = useTable();
const reviewersStore = useReviewers();

const handleArchive = async (reviewer) => {
  tableStore.deleting = reviewer._id;
  await reviewersStore.archiveReviewer(reviewer);
  await new Promise((resolve) => setTimeout(resolve, 1000));
  tableStore.deleting = null;
};
</script>
